import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import liff from '@line/liff';

import { environment } from '../../environments/environment';
@Injectable()
export class GetLineTokenService {
  constructor(public httpClient: HttpClient) {}

  // Core Function ! No modify
  async exec(liff_id: any, logger: any) {
    try{
        logger.info(['login liff start']);
        if(environment.production){
            logger.info(['login liff mode production start']);
            await liff.init({ liffId: liff_id});
          if(liff.isLoggedIn() === false && liff.isInClient() === false){
            logger.info(['login liff callback path:', window.location.href]);
            liff.login({ redirectUri: window.location.href })
          }else{
            const access_token = await liff.getAccessToken();
            logger.debug(['access_token_line:', access_token]);
            return access_token;
          }
        }else{
            logger.info(['login liff mode dev start']);
        }
    }catch(error){
        logger.error(['login liff error',error.message]);
        throw new Error(error.message);
    }  
  }
}
